import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { useLang } from '../context/LangContext';
import { downloadReport } from '../reportDownload';
import SendReportMailDialog from '../components/SendReportMailDialog';
import ReportPreview from '../components/ReportPreview';

export default function ReportsPage() {
  const { t, lang } = useLang();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mailReport, setMailReport] = useState(null);
  const [preview, setPreview] = useState(null);

  function load() {
    setLoading(true);
    api.get('/api/reports')
      .then(r => setReports(r.data))
      .finally(() => setLoading(false));
  }
  useEffect(load, []);

  async function handleDelete(id) {
    if (!window.confirm(t('rep_delete_confirm'))) return;
    await api.delete(`/api/reports/${id}`);
    load();
  }

  const fmtDate = (s) => new Date(s).toLocaleString(lang === 'en' ? 'en-GB' : 'nl-BE');

  return (
    <>
      <div className="page-header">
        <h2>{t('reports_title')}</h2>
      </div>

      <div className="page-body">
        {loading ? (
          <div className="spinner-border spinner-border-sm" />
        ) : reports.length === 0 ? (
          <div className="text-muted">{t('reports_none')}</div>
        ) : (
          <div className="card">
            <div className="table-responsive">
              <table className="table table-hover mb-0 align-middle">
                <thead>
                  <tr>
                    <th>{t('rep_col_audit')}</th>
                    <th>{t('rep_col_client')}</th>
                    <th>{t('rep_col_format')}</th>
                    <th>{t('rep_col_version')}</th>
                    <th>{t('rep_col_created')}</th>
                    <th>{t('rep_col_by')}</th>
                    <th style={{ width: 120 }} />
                  </tr>
                </thead>
                <tbody>
                  {reports.map(r => (
                    <tr key={r.id}>
                      <td>
                        <Link to={`/audits/${r.audit_id}`} className="text-decoration-none">
                          {r.audit_name}
                        </Link>
                      </td>
                      <td>{r.client_name || '—'}</td>
                      <td>
                        <span className={`badge ${r.format === 'pdf' ? 'bg-danger' : 'bg-primary'}`}>
                          {r.format.toUpperCase()}
                        </span>
                        <span className="text-muted small ms-2">
                          {r.include_recommendations ? t('rep_recs_yes') : t('rep_recs_no')}
                        </span>
                      </td>
                      <td>v{r.version}</td>
                      <td className="text-nowrap">{fmtDate(r.created_at)}</td>
                      <td>{r.created_by_name || '—'}</td>
                      <td className="text-end">
                        <button className="btn btn-sm btn-outline-secondary me-1"
                          onClick={() => setPreview(r)}
                          title={t('preview')}>
                          <i className="bi bi-eye" />
                        </button>
                        <button className="btn btn-sm btn-outline-primary me-1"
                          onClick={() => setMailReport(r)}
                          title={t('mail_send')}>
                          <i className="bi bi-envelope" />
                        </button>
                        <button className="btn btn-sm btn-outline-secondary me-1"
                          onClick={() => downloadReport(r.id, r.original_filename)}
                          title={t('rep_download')}>
                          <i className="bi bi-download" />
                        </button>
                        <button className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDelete(r.id)}
                          title={t('delete')}>
                          <i className="bi bi-trash" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {mailReport && (
        <SendReportMailDialog
          report={mailReport}
          clientId={mailReport.client_id}
          onClose={() => setMailReport(null)}
        />
      )}

      {preview && (
        <ReportPreview
          reportId={preview.id}
          filename={preview.original_filename}
          onClose={() => setPreview(null)}
        />
      )}
    </>
  );
}
